import TraceabilityPage from './pages/TraceabilityPage';
import ObligationsPage from './pages/ObligationsPage';
import DebitNotesPage from './pages/DebitNotesPage';
import { getAuthToken, getStoredProfile, clearAuthSession } from './services/authSession';
import { hasSessionHandoff, beginSessionHandoff } from './services/sessionHandoff';
import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from './components/layout/Sidebar';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import DossierPage from './pages/DossierPage';
import DeclarationsPage from './pages/DeclarationsPage';
import MonthEndPage from './pages/MonthEndPage';
import PaymentsPage from './pages/PaymentsPage';
import QuittancesPage from './pages/QuittancesPage';
import EstablishmentsPage from './pages/EstablishmentsPage';
import LicensesPage from './pages/LicensesPage';
import RenewalsPage from './pages/RenewalsPage';
import HistoryPage from './pages/HistoryPage';
import ReportsPage from './pages/ReportsPage';
import SettingsPage from './pages/SettingsPage';
import MessagingPage from './pages/MessagingPage';
import VideoCallPage from './pages/VideoCallPage';

function ProtectedLayout() {
  const profile = getStoredProfile();
  const token = getAuthToken();
  if (!token) return <Navigate to="/login" replace />;

  const handleLogout = () => {
    const token = getAuthToken();
    if (token) void fetch('/api/v1/auth/logout', { method: 'POST', headers: { Authorization: `Bearer ${token}` }, keepalive: true }).catch(() => undefined);
    clearAuthSession();
    window.location.href = '/login';
  };

  return (
    <Sidebar
      ownerName={profile?.name || profile?.hotel_name || 'Mon compte'}
      establishmentCount={profile?.establishment_count ?? 0}
      onLogout={handleLogout}
    >
      <Routes>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="dossier" element={<DossierPage />} />
 <Route path="traceability" element={<TraceabilityPage />} />
 <Route path="suivi-fpt" element={<ObligationsPage />} />
        <Route path="declarations" element={<DeclarationsPage />} />
        <Route path="month-end" element={<MonthEndPage />} />
            <Route path="debit-notes" element={<DebitNotesPage />} />
        <Route path="payments" element={<PaymentsPage />} />
        <Route path="quittances" element={<QuittancesPage />} />
        <Route path="establishments" element={<EstablishmentsPage />} />
        <Route path="licenses" element={<LicensesPage />} />
        <Route path="renewals" element={<RenewalsPage />} />
        <Route path="messages" element={<MessagingPage />} />
        <Route path="video" element={<VideoCallPage />} />
        <Route path="history" element={<HistoryPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Routes>
    </Sidebar>
  );
}

export default function App() {
  const [handoff, setHandoff] = useState(hasSessionHandoff() ? 'pending' : 'ready');
  const [handoffError, setHandoffError] = useState('');
  useEffect(() => {
    if (!hasSessionHandoff()) return;
    return beginSessionHandoff(() => setHandoff('ready'), message => { setHandoffError(message); setHandoff('error'); });
  }, []);
  if (handoff !== 'ready') return <div className="login-page"><div className="login-card">
    <h1>Connexion au Portail Assujetti FPT</h1>
    {handoff === 'pending' ? <p role="status">Vérification de votre session…</p> : <><p role="alert">{handoffError}</p><a className="btn primary" href="/login">Se connecter</a></>}
  </div></div>;
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/*" element={<ProtectedLayout />} />
      </Routes>
    </BrowserRouter>
  );
}
